/** Stable row keys for Catchball queue rows (must match localStorage in useCatchballQueueArchive). */
export function catchballTurnRowId(turnId: string): string {
  return `turn:${turnId}`;
}

export function catchballLegacyRowId(loopId: string): string {
  return `legacy:${loopId}`;
}
